<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view />
    </a-config-provider>
    <changelog-modal :is-show="visible" :changelog-data="changelog" @close="close" />
  </div>
</template>

<script>
import { getCookies } from '@/utils/utils';
import { changelogPush } from '@/api/system/about';
import { removeWatermark, setWaterMark } from '@/utils/watermark';

import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import ChangelogModal from '@/pages/system/components/ChangelogModal';

export default {
  name: 'App',
  components: { ChangelogModal },
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      locale: zhCN,
      visible: false,
      isRouterAlive: true,
      changelog: {},
      waterMark: false,
      token: getCookies()
    };
  },
  mounted() {
    const root = document.getElementById('root');
    setTimeout(() => {
      document.body.removeChild(root);
    }, 500);
  },
  created() {
    if (this.token) {
      this.$store.dispatch('getPermissions');
      this.$store.dispatch('getGlobalConfigList');
      this.$store.dispatch('getAllUsers');
      this.getChangelogPush();
    }
    this.$store.commit('setUserInfo');
    const waterMarkInterval = setInterval(() => {
      const userInfo = JSON.parse(window.localStorage.getItem('user_info') || '{}');
      // 加载水印
      if (Object.keys(userInfo).length > 0 && this.waterMark === false) {
        const phone = userInfo.phone ? userInfo.phone.slice(-4) : '';
        setWaterMark(`${userInfo.nickname} ${phone}`);
        this.waterMark = true;
        clearInterval(waterMarkInterval);
      }
    }, 1000);
  },
  beforeDestroy() {
    removeWatermark();
  },
  methods: {
    getChangelogPush() {
      if (this.token) {
        changelogPush().then(res => {
          this.visible = res.data.push;
          this.changelog = res.data.changelog;
        });
      }
    },
    close() {
      this.visible = false;
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>
